import React from 'react';
import { TopNavigation, Box, SpaceBetween } from '@cloudscape-design/components';

export const AuthLayout = ({ children, mode }) => {
  const isSummitLogin = mode === 'login';

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: isSummitLogin ? '#0D001F' : '#f9f9f9',
      backgroundImage: isSummitLogin ? "url('/summit/Sydney_AdobeStock_155673241.jpeg')" : 'none',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      <TopNavigation
        identity={{
          href: '/',
          logo: {
            src: '/images/logo/typeface_colour_blue_transparent.png',
            alt: 'ResearchIQ'
          }
        }}
      />
      
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 60px)',
        padding: '2rem'
      }}>
        <div style={{
          maxWidth: '400px',
          width: '100%',
          ...(isSummitLogin ? {
            backgroundColor: 'rgba(13, 0, 31, 0.05)',
            borderRadius: '12px',
            padding: '2rem',
            backdropFilter: 'blur(4px)',
          } : {})
        }}>
          <SpaceBetween size="l">
            <Box textAlign="center">
              <img 
                src="/images/logo/researchAI_Logo.png" 
                alt="ResearchIQ" 
                style={{ height: '60px', marginBottom: '1rem' }}
              />
            </Box>
            {children}
          </SpaceBetween>
        </div>
      </div>
    </div>
  );
};
